"use client";

import { buttonVariants } from "@rallly/ui";
import { FileSearchIcon } from "lucide-react";
import type * as React from "react";
import { LinkBase } from "@/i18n/client/link";
import { useTranslation } from "@/i18n/client/use-translation";

export interface ComponentProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
}

const ErrorPage: React.FunctionComponent<ComponentProps> = ({
  icon,
  title,
  description,
}) => {
  const { t } = useTranslation();
  return (
    <div className="inset-0 flex h-full w-full items-center justify-center lg:absolute">
      <div className="space-y-8">
        <div className="space-y-4">
          {icon || (
            <FileSearchIcon className="mb-4 inline-block size-24 text-gray-400" />
          )}
          <div className="mb-2 font-bold text-3xl text-primary">{title}</div>
          <p className="text-gray-600">{description}</p>
        </div>
        <div className="flex space-x-3">
          <LinkBase href="/" className={buttonVariants({ variant: "primary" })}>
            {t("goToHome")}
          </LinkBase>
          <a href="https://support.rallly.co" className={buttonVariants()}>
            {t("support")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
